// Copyright (c) 2022 Deere & Company

import ImplementSerialNumber from './implement-serial-number';
import File, {getDefaultState as getFileDefaultState} from './file';
import t from 'tcomb';

const Implements = t.struct({
    components: t.list(ImplementSerialNumber, 'Components'),
    file: File,
    isBaseMachineComponentAllowed: t.Boolean,
    pin: t.String,
    purchaseOrder: t.String
},{
    name: 'Implements',
    strict: true
});

export const getDefaultState = () => new Implements({
    components: [],
    file: getFileDefaultState(),
    isBaseMachineComponentAllowed: false,
    pin: '',
    purchaseOrder: ''
});

export default Implements;



// WEBPACK FOOTER //
// ./~/@deere/cps-it.warranty-model-factory/lib/implements.js